import {Component, Input} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {NavbarItemModel} from './navbar-item.model';

@Component({
    selector: 'navbar-link',
    template: `
      <div [routerLink]="!disabled ? navbarItem.routerLink : null" [state]="navbarItem.state" routerLinkActive="item-navbar-active"
        class="p-link inline-flex justify-content-center align-items-center text-white border-noround w-full nav-item-padding"
        [class.p-disabled]="disabled" [class.cursor-pointer]="!disabled" [class.nav-item-padding]="!navbarItem.parentItem">
        @if (!isChildren) {
          <div class="flex flex-column align-items-center justify-content-center nav-item-container">
            <i [class]="navbarItem.icon" class="nav-item-icon"></i>
            <span class="nav-item-text" routerLinkActive="item-active">{{ navbarItem.label }}</span>
          </div>
          @if (navbarItem.parentItem) {
            <span class="mdi mdi-chevron-right"></span>
          }
        } @else {
          <div class="flex align-items-center justify-content-center gap-2 nav-item-container">
            <i [class]="navbarItem.icon" class="nav-item-icon"></i>
            <span class="nav-item-text" routerLinkActive="item-active">{{ navbarItem.label }}</span>
          </div>
        }
      </div>
      `,
	imports: [RouterLinkActive, RouterLink],
    styleUrls: ['navbar.component.scss']
})
export class NavbarLinkComponent {

	@Input() navbarItem: NavbarItemModel;
	@Input() isChildren = false;
	@Input() disabled = false;

}
